import { supabase } from '../config/supabase';
import { v4 as uuidv4 } from 'uuid';

const VISITOR_ID_KEY = 'maploop_visitor_id';
const USER_ROLE_KEY = 'maploop_user_role';

/**
 * Génère ou récupère l'identifiant unique du visiteur
 */
export const getVisitorId = () => {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);
  
  if (!visitorId) {
    visitorId = uuidv4();
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }
  
  return visitorId;
};

/**
 * Vérifie si l'utilisateur est admin via Supabase
 */
const isUserAdmin = async (userId) => {
  // console.log('🟡 [TEMP LOG] isUserAdmin appelé avec userId:', userId);
  
  // Si pas de userId → pas admin
  if (!userId) {
    // console.log('⚪ [TEMP LOG] Pas de userId → pas admin');
    return false;
  }
  
  // Requête Supabase pour vérifier le rôle
  // console.log('🟢 [TEMP LOG] ⏳ Requête SUPABASE pour vérifier le rôle');
  const { data: profile, error } = await supabase
    .from('roles')
    .select('role')
    .eq('id', userId)
    .single();
  
  if (!error && profile?.role === 'admin') {
    // console.log('🟢 [TEMP LOG] ✅ Utilisateur ADMIN confirmé depuis SUPABASE');
    return true;
  }
  
  // console.log('🟢 [TEMP LOG] ✅ Utilisateur NON admin (ou erreur)');
  return false;
};

/**
 * Nettoie le cache du rôle utilisateur (à appeler lors de la déconnexion)
 */
export const clearUserRoleCache = () => {
  localStorage.removeItem(USER_ROLE_KEY);
};

/**
 * Extrait l'event_id depuis le path si c'est une page d'événement
 */
const extractEventId = (pagePath) => {
  const eventPathRegex = /^\/event\/([a-f0-9-]{36})$/i;
  const match = pagePath.match(eventPathRegex);
  return match ? match[1] : null;
};

/**
 * Enregistre une visite de page
 * OPTIMISÉ : Exécution asynchrone sans attendre la réponse
 */
export const trackPageVisit = async (pagePath, pageTitle, userId = null) => {
  // console.log('📊 [TEMP LOG] trackPageVisit appelé - pagePath:', pagePath, 'userId:', userId);
  
  try {
    // Vérifier si l'utilisateur est admin
    const isAdmin = await isUserAdmin(userId);
    
    if (isAdmin) {
      // console.log('🚫 [TEMP LOG] Utilisateur ADMIN → visite NON tracée');
      return;
    }

    // console.log('✅ [TEMP LOG] Utilisateur non-admin → visite TRACÉE');

    // Utilise uniquement l'UUID local pour identifier le visiteur
    const visitorId = getVisitorId();
    const eventId = extractEventId(pagePath);
    
    const visitData = {
      visitor_id: visitorId,
      // user_id retiré pour préserver l'anonymat
      page_path: pagePath,
      page_title: pageTitle || document.title,
      referrer: document.referrer || null,
      language: navigator.language || navigator.userLanguage,
      event_id: eventId
    };
    
    // Fire-and-forget : on n'attend pas la réponse
    supabase
      .from('visits')
      .insert(visitData)
      .then(({ error }) => {
        if (error) {
          console.error('Erreur lors de l\'enregistrement de la visite:', error);
        } else {
          // console.log('💾 [TEMP LOG] Visite enregistrée avec succès');
        }
      })
      .catch((error) => {
        console.error('Erreur lors du tracking:', error);
      });
  } catch (error) {
    console.error('Erreur lors du tracking:', error);
  }
};

/**
 * Récupère les statistiques de visites (pour les admins)
 */
export const getVisitStats = async (startDate, endDate) => {
  try {
    let query = supabase
      .from('visits')
      .select('*', { count: 'exact' });
    
    if (startDate) {
      query = query.gte('visited_at', startDate);
    }
    
    if (endDate) {
      query = query.lte('visited_at', endDate);
    }
    
    const { data, error, count } = await query;
    
    if (error) throw error;
    
    return { data, count };
  } catch (error) {
    console.error('Erreur lors de la récupération des stats:', error);
    throw error;
  }
};
